module.exports = __webpack_public_path__ + "img/ico-contact-company_1.9752dd85.svg";